import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-job-modal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "confirm-job-modal--title" }, "Please confirm you action", -1)
const _hoisted_3 = ["disabled", "onClick"]

import BottomModal from "@/components/BottomModal.vue";
import { useConfirmBooking } from '@/store/booking'
import type { Booking } from '@/models/your-bookings'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmJobModal',
  props: {
    show: { type: Boolean },
    bookingId: null
  },
  emits: ["close", "confirmed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'confirmed', v: Booking): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  bookingId: number;
};





const { confirmBooking, error, isPending } = useConfirmBooking(props.bookingId)

const onSubmit = async () => {
  emit('confirmed', await confirmBooking())
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createBlock(BottomModal, {
    show: __props.show,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    size: "sm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Error, { error: _unref(error) }, null, 8, ["error"]),
        _hoisted_2,
        _createElementVNode("button", {
          disabled: _unref(isPending),
          onClick: _withModifiers(onSubmit, ["prevent"]),
          class: "btn btn-cancel btn-block confirm-job-modal--confirm-btn"
        }, " confirm job ", 8, _hoisted_3),
        _createElementVNode("button", {
          class: "btn btn-block btn-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
        }, " back to booking details ")
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})